import React from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { NotoSansJp } from "./TextStyle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useBranch, Navigate } from "./useBranch";

const Join = () => {
  const isSmartphone = useMediaQuery("(max-width:767px)");
  const state = useBranch();
  if (state.status === "loading") return null;
  if (state.status === "notfound") return <Navigate to="/" replace />;
  const branch = state.branch;

  const steps = [
    {
      number: "01",
      title: "体験教室のお申し込み",
      description: "体験フォームより体験レッスンのご予約をお願いいたします。",
      buttonLabel: "体験を申し込む",
      buttonColor: "#E0B24B",
      url: branch.freeTrialUrl,
    },
    {
      number: "02",
      title: "ご入会",
      description: "入会手続きは、下記フォームからご登録お願いいたします。",
      buttonLabel: "入会手続きへ",
      buttonColor: "#E0B24B",
      url: branch.membershipUrl,
    },
    {
      number: "03",
      title: "入会後予約",
      description: "下記のWebアプリから予約のご登録お願いいたします。",
      buttonLabel: "レッスン予約",
      buttonColor: "#E0B24B",
      url: branch.loginUrl,
    },
  ];

  return (
    <>
      <Box sx={{ width: "100vw" }}>
        <Grid
          container
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ width: "100vw" }}>
            <Grid
              container
              direction="column"
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: "100%", mt: isSmartphone ? "40px" : "100px" }}>
                <Grid
                  container
                  direction="column"
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    p: isSmartphone ? "0 7%" : "0",
                  }}
                >
                  <Typography
                    component="h1"
                    sx={{
                      color: "darkorange",
                      fontSize: isSmartphone ? "20px" : "35px",
                      fontWeight: "bold",
                      pt: isSmartphone ? "0" : "50px",
                      mb: isSmartphone ? "10px" : "20px",
                      ...NotoSansJp,
                    }}
                  >
                    {branch.roomName}｜入会までの流れ
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#333333",
                      mb: "40px",
                    }}
                  >
                    <HomeIcon fontSize="small" />
                    <Typography
                      sx={{ fontSize: isSmartphone ? "14px" : "16px", mx: 1 }}
                    >
                      {">"}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#333333",
                        fontWeight: 500,
                        fontSize: isSmartphone ? "14px" : "16px",
                        ...NotoSansJp,
                      }}
                    >
                      入会までの流れ
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      mt: isSmartphone ? " 50px" : "120px",
                      mb: isSmartphone ? "50px" : "120px",
                    }}
                  >
                    <Box
                      sx={{
                        maxWidth: "800px",
                        mr: "auto",
                        ml: "auto",
                        position: "relative",
                      }}
                    >
                      {steps.map((step, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            position: "relative",
                            zIndex: 1,
                          }}
                        >
                          {/* 番号バッジ */}
                          <Box
                            sx={{
                              position: "absolute",
                              left: 0,
                              top: 0,
                              width: isSmartphone ? "40px" : "60px",
                              height: isSmartphone ? " 40px" : "60px",
                              lineHeight: isSmartphone ? " 40px" : "60px",
                              textAlign: "center",
                              bgcolor: "#F0F7FC",
                              fontSize: isSmartphone ? "12px" : "16px",
                              zIndex: 2,
                              borderRadius: "50px",
                              color: "#333333",
                            }}
                          >
                            {step.number}
                          </Box>

                          {/* テキスト部分 */}
                          <Box
                            sx={{
                              p: isSmartphone
                                ? index === 2
                                  ? "0 0 0 60px"
                                  : "0 0 36px 60px"
                                : "0 0 36px 100px",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#E0B24B",
                                fontSize: isSmartphone ? "18px" : "20px",
                                fontWeight: "bold",
                                mb: "20px",
                                ...NotoSansJp,
                              }}
                            >
                              {step.title}
                            </Typography>
                            <Typography
                              sx={{
                                color: "#333",
                                fontWeight: 500,
                                fontSize: isSmartphone ? "14px" : "16px",
                                ...NotoSansJp,
                              }}
                            >
                              {step.description}
                            </Typography>

                            {/* ボタン */}
                            <Button
                              variant="contained"
                              href={step.url}
                              sx={{
                                bgcolor: step.buttonColor,
                                color: "#fff",
                                fontWeight: "bold",
                                px: 4,
                                py: 1,
                                fontSize: isSmartphone ? 12 : 14,
                                "&:hover": {
                                  bgcolor: step.buttonColor,
                                  opacity: 0.9,
                                },
                              }}
                            >
                              {step.buttonLabel}
                            </Button>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Box>
    </>
  );
};

export default Join;
